import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import AgentModal from '../components/AgentModal/AgentModal';

const AgentModalContext = createContext(undefined);

export function AgentModalProvider({ children }) {
  const [state, setState] = useState({
    isOpen: false,
    agentId: null,
    origin: undefined,
    contextPayload: undefined,
  });

  const openAgentModal = ({ agentId, origin, contextPayload }) => {
    setState({
      isOpen: true,
      agentId,
      origin,
      contextPayload,
    });
  };

  const closeAgentModal = () => {
    setState((prev) => ({ ...prev, isOpen: false }));
  };

  const switchAgentModal = (agentId) => {
    if (!agentId) return;
    setState((prev) => ({
      ...prev,
      isOpen: true,
      agentId,
    }));
  };

  return (
    <AgentModalContext.Provider
      value={{ state, openAgentModal, closeAgentModal, switchAgentModal }}
    >
      {children}
      {state.isOpen && <AgentModal />}
    </AgentModalContext.Provider>
  );
}

AgentModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAgentModal() {
  const ctx = useContext(AgentModalContext);
  if (!ctx) {
    throw new Error('useAgentModal must be used within AgentModalProvider');
  }
  return ctx;
}
